<template>
    <div id="modal-mail-group-edit" class="modal fade" data-keyboard="false">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-body">
                    <div class="d-flex mb-3">
                        <div class="pt-2 text-nowrap">システム送信</div>
                        <div class="flex-fill pl-2">
                            <select v-model.trim="groupStatus" class="form-control">
                                <option value="">-- 選択 --</option>
                                <option value="0">送信可能(一括)</option>
                                <option value="1">送信禁止(一括)</option>
                            </select>
                        </div>
                    </div>
                    <div class="d-flex mb-3">
                        <div class="pt-2 text-nowrap">グループ名称</div>
                        <div class="flex-fill pl-2">
                            <input v-model.trim="groupNm" type="text" class="form-control" maxlength="20" :disabled="disableDelBtn" spellcheck=false value="">
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <div class="container">
                        <div class="row">
                            <div class="col-6">
                                <button :disabled="disableSaveBtn" class="btn btn-success btn-block m-0" type="button" @click="groupSave" >
                                    保存する
                                </button>
                            </div>
                            <div class="col-6">
                                <button :disabled="disableDelBtn" class="btn btn-danger btn-block m-0" type="button" @click="groupDel">
                                    グループ削除
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {EventBus} from 'js/event-bus'
    import {mapGetters} from 'vuex'

    export default {
        data () {
            return {
                groupStatus: '',
                groupType: '',
                groupId: '',
                groupNm: '',
                groupNmInit: '',
            }
        },
        watch: {
            getMailGroupEditSaveStatus (status) {
                if (status == 1) {
                    this.$store.dispatch('startSpinner')
                }
                if (status == 2) {
                    this.hideThis()
                    this.$store.dispatch('doneSpinner')
                }
                if (status == 3) {
                    this.hideThis()
                    this.$store.dispatch('doneSpinner')
                }
            },
            getMailGroupEditDelStatus (status) {
                if (status == 1) {
                    this.$store.dispatch('startSpinner')
                }
                if (status == 2) {
                    this.$parent.delGroupSelected(this.groupId)
                    this.hideThis()
                    this.$store.dispatch('doneSpinner')
                }
                if (status == 3) {
                    this.hideThis()
                    this.$store.dispatch('doneSpinner')
                }
            }
        },
        computed: {
            disableSaveBtn () {
                if (this.groupStatus != '') {
                    return false
                }
                if (this.groupNm.trim() != this.groupNmInit) {
                    return false
                }
                return true
            },
            disableDelBtn () {
                return this.$parent.is_const_id
            },
            ...mapGetters(['getMailGroupEditSaveStatus', 'getMailGroupEditDelStatus'])
        },
        methods: {
            groupSave () {
                this.$store.dispatch('mailGroupEditSave', {
                    groupStatus: this.groupStatus,
                    groupType: this.groupType,
                    groupId: this.groupId,
                    groupNm: this.groupNm,
                    groupNmChanged: this.groupNm == this.groupNmInit ? false : true
                })
            },
            groupDel () {
                    let lev = 2
                    let msg = 'このグループを削除しますか？'
                    let key = 'groupDel' 
                    this.$parent.openMsg(lev, msg, key, this.groupId)
                    this.hideThis()
            },
            openThis (group_type, group_id, group_nm) {
                this.resetThis()
                this.groupType = group_type
                this.groupId = group_id
                this.groupNm = group_nm
                this.groupNmInit = this.groupNm
                $('#modal-mail-group-edit').modal('show')
            },
            hideThis () {
                $('#modal-mail-group-edit').modal('hide')
            },
            resetThis () {
                this.groupStatus = ''
                this.groupType = ''
                this.groupId = ''
                this.groupNm = ''
                this.groupNmInit = ''
            }
        }
    }
</script>

<style>

</style>
